/**
 * meshConvert.js — конвертер сеток между двумя мирами программы. [11.1.22]
 *
 * ПОВОД — сведение по слову владельца («своди»): «Построить поверхность» на
 * вкладке GPU считает marching cubes на видеокарте и отдаёт ТРЕУГОЛЬНЫЙ СУП
 * (vertices: по три вершины на грань подряд, без индексов, координаты — В
 * ВОКСЕЛЯХ, шаг не учтён). А весь ряд «3D модель: обработка и выгрузка»
 * (Децимация/Сгладить/GLTF/VRML/STL, vtkModule) ест VTK-формат:
 * points (мм) + polys вида [3, a, b, c, 3, …]. До 11.1.22 миры не знали друг
 * о друге, и обработка пересчитывала свою сетку заново.
 *
 * ЗДЕСЬ — только чистая математика, ноль импортов (приём wlChips/wlManual):
 * verify гоняет её на игрушечном супе без DOM и без видеокарты.
 *
 * Перевод в мм обязателен: срез КТ обычно 0.7×0.7×3 мм — без умножения на
 * шаг модель по Z сплющена вчетверо, и STL-файл был бы геометрической ложью.
 */

/**
 * @param {Float32Array|number[]} vertices — суп: x,y,z подряд, тройки вершин = грань
 * @param {number} vertexCount — сколько вершин (кратно 3)
 * @param {number[]} [spacing] — шаг вокселя, мм: [sx, sy, sz]
 * @returns {{points:Float32Array, polys:Uint32Array, triangleCount:number}|null}
 */
export function гпуСупВVtk(vertices, vertexCount, spacing = [1, 1, 1]) {
  const n = Math.floor((Number(vertexCount) || 0) / 3) * 3;   // хвост неполной грани отбрасываем
  if (!vertices || n < 3) return null;
  const [sx, sy, sz] = [Number(spacing?.[0]) || 1, Number(spacing?.[1]) || 1, Number(spacing?.[2]) || 1];
  const points = new Float32Array(n * 3);
  for (let i = 0; i < n; i++) {
    points[i * 3]     = vertices[i * 3]     * sx;
    points[i * 3 + 1] = vertices[i * 3 + 1] * sy;
    points[i * 3 + 2] = vertices[i * 3 + 2] * sz;
  }
  const triangleCount = n / 3;
  const polys = new Uint32Array(triangleCount * 4);
  for (let t = 0; t < triangleCount; t++) {
    const j = t * 4;
    polys[j] = 3;
    polys[j + 1] = t * 3;
    polys[j + 2] = t * 3 + 1;
    polys[j + 3] = t * 3 + 2;
  }
  return { points, polys, triangleCount };
}

export default { гпуСупВVtk };
